const checkWidget = (e) => {
  var checkAllFields = e.type == "submit";
  var currentField = e.target;

  if (checkAllFields) {
    document.querySelectorAll(".js-form-error").forEach((errorLabel) => {
      errorLabel.setAttribute("hidden", "hidden");
    });
  } else {
    document.querySelector(currentField.dataset.errorLabel).setAttribute("hidden", "hidden");
  }

  if ((checkAllFields || currentField == hiddenLocationInput) && hiddenLocationInput.value == "") {
    e.preventDefault();

    document.querySelector(hiddenLocationInput.dataset.errorLabel).removeAttribute("hidden");
  }

  if ((checkAllFields || currentField == hiddenUsageInput) && hiddenUsageInput.value == "") {
    e.preventDefault();

    document.querySelector(hiddenUsageInput.dataset.errorLabel).removeAttribute("hidden");
  }
};

class checkInputWidgetValidation {
  constructor(form) {
    const hiddenLocationInput = document.getElementById("hiddenLocationInput");
    const hiddenUsageInput = document.getElementById("hiddenUsageInput");

    form.addEventListener("submit", checkWidget);

    hiddenLocationInput.addEventListener("change", checkWidget);
    hiddenUsageInput.addEventListener("change", checkWidget);
  }
}
export { checkInputWidgetValidation };
